import React, { useState } from 'react'
import SRCards from '../../components/SRCards'
import { Button, Container, Dialog, DialogTitle, DialogContent, DialogActions, Snackbar } from '@material-ui/core'
import CommonServiceApi from '../../services/common-service'
import { Alert } from '@material-ui/lab';
import SelectCompany from '../../components/SelectCompany';

export default function TriggerAnnouncementList() {
    const [allCompanies, setAllCompanies] = useState(true);
    const [dialog, setDialog] = useState(false);
    const [snackBar, setSnackBar] = useState('');
    const [confirmMsg, setConfirmMsg] = useState('');
    const [pageResponse, setPageResponse] = useState('');
    const apiservices = new CommonServiceApi();

    const confirm = (e: any) => {
        let res = `This operation will trigger announcement for the selected company. Are you sure?`
        setDialog(true);
        setConfirmMsg(res);
        setAllCompanies(false);
        return
    }

    const confirmAll = (e: any) => {
        let res = `This operation will trigger announcement for the all companies. Are you sure?`
        setDialog(true);
        setConfirmMsg(res);
        setAllCompanies(true);
        return
    }

    const cancel = () => {
        setDialog(false);
        setSnackBar('info');
        setPageResponse(`Cancelled.`);
    }

    const triggerAnnouncementForCompany = async () => {
        let companyIds = []
        if (!allCompanies) {
            companyIds.push(localStorage.getItem('selectedCompanyId'));
        }
        else {
            companyIds.push('*');
        }
        let response = await apiservices.triggerAnnouncement(companyIds);
        if (response && (response[0] || response === true)) {
            setDialog(false);
            setSnackBar('success');
            setPageResponse("Trigger Announcement Successful.")
        }
        else {
            let msg;
            if (response && response.message && response.description) {
                msg = `Trigger Announcement Failed: ${response.message} - ${response.description}`
            } else {
                msg = `Trigger Announcement Failed.`
            }
            setDialog(false);
            setSnackBar('error');
            setPageResponse(msg);
        }
    }

    return (
        <>
            <SRCards />
            <Container>
            <SelectCompany/>
            <br/><br/>
                <Button className='trigger_announcement_body'
                    onClick={confirm}
                    style={{ margin: 10 }}
                    variant='outlined'> Trigger Announcement for The Selected Company</Button>
                <br></br><br></br>
                {/* <Button className='trigger_announcement_body'
                    onClick={confirmAll}
                    style={{ margin: 10 }}
                    variant='outlined'> Trigger Announcement for All Companies</Button> */}
                <Dialog
                    open={dialog}
                    onClose={() => {
                        setDialog(false)
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        {'Confirmation!'}
                    </DialogTitle>
                    <DialogContent>
                        {confirmMsg}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={
                                () => {
                                    setConfirmMsg('Processing...')
                                    triggerAnnouncementForCompany()
                                }
                            }
                        >
                            Confirm
                        </Button>
                        <Button
                            onClick={
                                () => cancel()
                            }
                            autoFocus
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <Snackbar
                    open={snackBar === '' ? false : true}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    autoHideDuration={6000}
                    onClose={() => {
                        setSnackBar('')
                    }}
                >
                    <Alert
                        severity={snackBar === 'error' ? 'error' : 'success'}
                        onClose={() => {
                            setSnackBar('')
                        }
                        }>
                        {pageResponse}
                    </Alert>
                </Snackbar>
            </Container>
        </>
    )
}
